import './maintenance-planning.scss';

import React from 'react';
import { useContractTypes } from '../../contexts/contract-types';

import Button from 'devextreme-react/button';
import Calendar from 'devextreme-react/calendar';
import Scheduler, { Resource, SchedulerTypes } from 'devextreme-react/scheduler';
import SpeedDialAction from 'devextreme-react/speed-dial-action';
import Tooltip from 'devextreme-react/tooltip';

import { useScreenSize } from '../../utils/media-query';
import { Popup, ToolbarItem } from 'devextreme-react/popup';
import { useSchedulerLogic } from './use-scheduler-logic';
//import { MaintenanceForm } from '../../components/library/forms/maintenance-form';
import { CalendarList } from '../../components/utils/calendar-list/calendar-list';
import { LeftSidePanel } from '../../components/utils/left-side-panel/left-side-panel';
import { RightSidePanel } from '../../components/utils/right-side-panel/right-side-panel';
import { Agenda } from '../../components/utils/agenda/agenda';
import { TooltipContentTemplate } from '../../components/library/scheduler-tooltip/scheduler-tooltip';
import { WorkTaskForm } from '../../components/library/forms/workTask-form';
import { MoveMaintenance } from '../../components/library/maintenance/MoveMaintenance';
const views: SchedulerTypes.ViewType[] = ['day', 'workWeek', 'month', 'agenda'];

const onAppointmentFormOpening = (e: SchedulerTypes.AppointmentFormOpeningEvent) => {
  e.cancel = true;
};

export const MaintenancePlanning = () => {
  const { isXSmall, isSmall } = useScreenSize();
  const { contractTypeResources, resourcesList } = useContractTypes();
  const {
    agendaItems,
    currentView,
    date,
    rightPanelOpen,
    schedulerRef,
    schedulerCurrentDate,
    selectedAppointment,
    tasks,
    tooltipPosition,
    tooltipRef,
    onCurrentViewChange,
    onAppointmentClick,
    onAppointmentTooltipShowing,
    onAppointmentModified,
    onCellClick,
    onSelectedDateChange,
    onSelectedCalendarsChange,
    showAppointmentTooltip,
    showAppointmentCreationForm,
    toggleRightPanelOpen,
    createRemoteTask,
    addTaskPopupOpen,
    hideInfo,
    closeButtonOptions,
    addTaskHidePopup,
    onOptionChanged,
    moveTask,
    moveTaskPopupOpen
  } = useSchedulerLogic();

  return <div className='view-wrapper-calendar'>
    <div className='calendar-content'>
      <LeftSidePanel>
        <div className={isXSmall || isSmall ? 'left-content small' : 'left-content'}>
          <div className='buttons'>
            <Button
              text='Vandaag'
              onClick={onSelectedDateChange}
            />
            <Button
              visible={false}
              text='Opdracht aanmaken'
              type='default'
              onClick={showAppointmentCreationForm}
            />
          </div>
          <div className='calendar'>
            <Calendar
              value={date}
              onValueChange={onSelectedDateChange}
              onOptionChanged={onOptionChanged}
            />
          </div>
          <CalendarList
            calendarItems={contractTypeResources}
            onSelectedCalendarsChange={onSelectedCalendarsChange}
          />
        </div>
      </LeftSidePanel>
      <div className='main-content'>
        <Scheduler
          ref={schedulerRef}
          adaptivityEnabled={isXSmall}
          allDayPanelMode='hidden'
          defaultCurrentView='month'
          dataSource={tasks}
          height='inherit'
          currentDate={schedulerCurrentDate}
          currentView={currentView}
          onCurrentViewChange={onCurrentViewChange}
          onAppointmentAdded={onAppointmentModified}
          onAppointmentClick={onAppointmentClick}
          onAppointmentDeleted={onAppointmentModified}
          onAppointmentFormOpening={onAppointmentFormOpening}
          onAppointmentTooltipShowing={onAppointmentTooltipShowing}
          onCellClick={onCellClick}
          onOptionChanged={onOptionChanged}
          showCurrentTimeIndicator={false}
          startDayHour={4}
          views={views}
        >
          <Resource
            dataSource={resourcesList}
            fieldExpr='calendarId'
            label='Calendar'
          />
        </Scheduler>
        <SpeedDialAction
          icon='add'
          visible={isXSmall}
          onClick={showAppointmentCreationForm}
        />
        <Tooltip
          ref={tooltipRef}
          target={selectedAppointment?.target}
          showEvent='click'
          position={tooltipPosition}
        >
          <TooltipContentTemplate
            moveTask={moveTask}
            createRemoteTask={createRemoteTask}
            selectedAppointmentData={selectedAppointment?.data} />
        </Tooltip>
      </div>
      <RightSidePanel
        showOpenButton={currentView === 'month'}
        isOpened={rightPanelOpen}
        toggleOpen={toggleRightPanelOpen}
      >
        <Agenda
          selectedAppointmentData={selectedAppointment?.data}
          toggleOpen={toggleRightPanelOpen}
          items={agendaItems?.sort((a, b) => {
            const cityA = a.City || '';
            const cityB = b.City || '';
            return cityA.localeCompare(cityB);
          })}
          resources={resourcesList}
          showAppointmentTooltip={showAppointmentTooltip}
        />
      </RightSidePanel>
      <Popup
        visible={addTaskPopupOpen}
        onHiding={hideInfo}
        dragEnabled={false}
        hideOnOutsideClick
        showCloseButton={false}
        showTitle
        title='Opdracht aanmaken'
        width={600}
        height={650}>
        <ToolbarItem
          widget='dxButton'
          toolbar='top'
          location='after'
          options={closeButtonOptions} />
        <WorkTaskForm
          appointmentData={[]}
          workTaskOid=''
          contractOid={selectedAppointment?.data.ContractOid}
          onComplete={addTaskHidePopup} />
        {/* <MaintenanceForm
                  contractOid={selectedAppointment?.data.ContractOid}
                  relationId={selectedAppointment?.data.RelationCustomerId}
                  contractType={selectedAppointment?.data.ContractType}
                  onComplete={addTaskHidePopup}
              /> */}
      </Popup>
      <Popup
        visible={moveTaskPopupOpen}
        onHiding={addTaskHidePopup}
        dragEnabled={false}
        hideOnOutsideClick
        showCloseButton={false}
        showTitle
        title='Onderhoud verplaatsen'
        width={300}
        height={200}>
        <ToolbarItem
          widget='dxButton'
          toolbar='top'
          location='after'
          options={closeButtonOptions} />
        <MoveMaintenance
          contractOid={selectedAppointment?.data.ContractOid}
          onComplete={addTaskHidePopup}
        />
      </Popup>

    </div>
  </div>;
};
